import { useSelector } from "react-redux";
import store from "../../storeWire";
import {
  setFilterList,
  clearFilterByKey,
  clearAllFilter,
  clearArryVal
} from "../../store/slice/model/Admin/AdminAccountFilter";

export function useAdminAccountFilterStore () {
  const filter_list = useSelector((state) => state.entities.model_Admin_common_filter.filterList)

  const data = {
    filter_list
  };
  const fetch = {
  };
  const set = {
    set_filter_list: async (params) => {
      return await store.dispatch(setFilterList(params))
    },
    clear_filter_by_key: async (params) => {
      return await store.dispatch(clearFilterByKey(params))
    },
    clear_all_filter: async () => {
      return await store.dispatch(clearAllFilter())
    },
    clear_arry_value: async (params) => {
      return await store.dispatch(clearArryVal(params))
    }
  };

  return [ data, fetch, set ]
}